import { ComponentDefaultMessageVO } from '@repo/types'
import { fetcher } from '../utils'

export default async (title: string): Promise<ComponentDefaultMessageVO> =>
  fetcher(`/api/tag/title/${title}`, 'GET', undefined)
